import { indexTopics } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">主题索引</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">按国家和类型快速找到你想看的漫画，分类清晰一目了然</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexTopics.map((item) => (
            <a
              key={item.id}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="group flex flex-col items-center text-center p-6 bg-background-100 rounded-xl border border-background-200/50 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-primary-100 group-hover:bg-primary-200 transition-colors mb-4">
                <span className="w-7 h-7 flex items-center justify-center">
                  <i className={`${item.icon} text-primary-500 text-xl`}></i>
                </span>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">{item.name}</h3>
              <span className="text-xs px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 font-medium mb-2 whitespace-nowrap">{item.count}</span>
              <p className="text-xs text-foreground-600 leading-relaxed">{item.description}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}